import React from 'react';
import { L1IconType } from '@fiverr-private/visuals';

// @TODO: Remove when icon will be published in penta visuals package
export const SentIcon = ({ size }: L1IconType) => {
    const sizes = size === 'sm' ? { width: '24', height: '24' } : { width: '32', height: '32' };

    return (
        <svg {...sizes} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.3334 16.666L20.0001 11.9993M15.3334 16.666L3.83439 14.0829C2.37093 13.7503 2.24899 11.7125 3.66233 11.2077L27.3259 2.75643C28.5178 2.33076 29.6686 3.48157 29.243 4.67344L20.7917 28.3371C20.2869 29.7504 18.2491 29.6285 17.9165 28.1651L15.3334 16.666Z"
                stroke="#222325"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
